import PaymentSuccessModal from './PaymentSuccessModal';
export default PaymentSuccessModal;
